import { render, staticRenderFns } from "./Usps.vue?vue&type=template&id=7e6137a4&"
import script from "./Usps.vue?vue&type=script&lang=js&"
export * from "./Usps.vue?vue&type=script&lang=js&"
import style0 from "./Usps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports